<div class="pageContent">
  <div class="pageTitle">
    <h2>Iniciar Proceso</h2>
  </div>
  <!-- <div class="ms-Dropdown" tabindex="0">
    <label class="ms-Label">Seleccione un Proceso a ejecutar</label>
    <i class="ms-Dropdown-caretDown ms-Icon ms-Icon--ChevronDown"></i>
    <select class="ms-Dropdown-select" id="select-procesos"></select>
  </div> -->
  <form [formGroup]="initProcessForm" (ngSubmit)="createEjecucionProceso()" name="initProcessForm">
    <div class="ms-Dialog-content input-grid form-group">
      <app-combo-box [frm]="initProcessForm" formControlName="idProceso" type="process" [required]="true" label="Proceso a ejecutar" classField="dropdown-process" [searchable]="true"></app-combo-box>
    </div>
    <div style="margin-top: 24px;" [hidden]="botonProcesando">
      <button
        type="submit"
        class="ms-Button ms-Button--primary"
        [disabled]="initProcessForm.invalid"
      >
        <span id="btnCreateEdit" class="ms-Button-label">Aceptar</span>
      </button>
    </div>
  </form>
  <div class="ms-Spinner" [hidden]="!botonProcesando">
    <div class="ms-Spinner-label">
      {{ textoBotonProcesando }}
    </div>
  </div>

  <!-- <button class="ms-Button" (click)="createEjecucionProceso()">
    <span class="ms-Button-label">Aceptar</span>
  </button> -->
</div>


<app-modal-notify #crearModal></app-modal-notify>
